import { getApiBaseUrl } from '../config/apiBase';

/**
 * @param {string} deviceId
 * @param {{ signal?: AbortSignal }} [options]
 * @returns {Promise<{ success: boolean, phone: string | null }>}
 */
export async function fetchMinisiteContinueMobilePhone(deviceId, options = {}) {
  const base = getApiBaseUrl();
  const q = new URLSearchParams({ deviceId: String(deviceId).trim() });
  const r = await fetch(`${base}/api/minisite-continue-mobile?${q.toString()}`, {
    cache: 'no-store',
    signal: options.signal,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    throw new Error(data.error || `HTTP ${r.status}`);
  }
  return data;
}

/**
 * @param {string} deviceId
 * @param {string} countryCode e.g. "+972"
 * @param {string} nationalNumber digits (Israeli mobile, 9 digits starting with 5)
 * @returns {Promise<{ success: boolean, phone?: string }>}
 */
export async function submitMinisiteContinueMobile(deviceId, countryCode, nationalNumber) {
  const base = getApiBaseUrl();
  const r = await fetch(`${base}/api/minisite-continue-mobile`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    cache: 'no-store',
    body: JSON.stringify({
      deviceId: String(deviceId).trim(),
      countryCode: String(countryCode).trim(),
      nationalNumber: String(nationalNumber).trim(),
    }),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    throw new Error(data.error || `HTTP ${r.status}`);
  }
  return data;
}
